import { createContext, useContext, useEffect, useRef, useState } from 'react'

import {
  authLogin,
  enviarCodigoMFA as enviarCodigoMfaApi,
  validarCodigoMFA as validarCodigoMfaApi
} from '../api/auth'
import useLocalStorage from '../hooks/useLocalStorage'
import { AddProfile, AddTenant, AddToken, AddUserHeader } from '../services/api'

import { useHistory } from 'react-router-dom'
import { SynPerfis } from 'src/core/consts/synPerfis'
import { SynRoutes } from 'src/core/consts/synRoutes'
import {
  AuthResponse,
  AuthSynSaude,
  CanalDisponivel,
  MfaEtapa1Response,
  MfaEtapa2Response,
  PendenciaBacenEstado,
  PerfilTentantResponse,
  UserAuth
} from 'src/types'
import { ModalAtualizacoesContext } from './ModalAtualizacoes'
import { mostrarTutorial } from 'src/api/usuario'
import { IResumoNotificacao } from 'src/components/notificacoes/menu'

import _notificacoes from 'src/api/notificacao'

import TipoTermo from 'src/core/consts/tipoTermo'
import SynTipoParceiro from 'src/core/consts/synTipoParceiro'
import { showNotificationErrorAPI } from 'src/core/helpers/notification'
import { obterMinhasPendencias } from 'src/api/recebedor-pendencia-bacen'
const AuthContext = createContext<AuthSynSaude>({} as any)

const tenantSyn = '3317a776-e06b-4afc-b755-b8880f612a8d'
const estadoSemPendencia: PendenciaBacenEstado = {
  temPendencia: false,
  dataLimite: null,
  bloqueioAtivo: false,
  total: 0,
  itens: []
}

/** Perfis alinhados ao [AuthorizeRoles] de GET minhas-pendencias (RF10 / CA-09 / CA-10). */
const perfisConsultaPendenciaBacen = new Set([
  SynPerfis.MEDICO,
  SynPerfis.ADMIN_HOSPITAL,
  SynPerfis.TESOURARIA_HOSPITAL,
  SynPerfis.PARCEIRO,
  SynPerfis.PARCEIRO_EXTERNO,
  SynPerfis.SUPER_ADMIN
])

function perfilConsultaPendenciaBacen(perfil?: string | null) {
  return !!perfil && perfisConsultaPendenciaBacen.has(perfil)
}
export const AuthProvider = ({ children }) => {
  const [
    mostrouTutorialLogado,
    setMostrouTutorialLogado,
    removeMostrouTutorialLogado
  ] = useLocalStorage('@authApp: MostrouTutorialLogado')
  const [storageUser, setStorageUser, removeStorageUser] = useLocalStorage(
    '@authApp: user'
  )
  const [
    storageProfile,
    setStorageProfile,
    removeStorageProfile
  ] = useLocalStorage('@authApp: profile')
  const [
    storageTenant,
    setStorageTenant,
    removeStorageTenant
  ] = useLocalStorage('@authApp: tenant')
  const [storageToken, setStorageToken, removeStorageToken] = useLocalStorage(
    '@authApp: token'
  )
  const [
    storageLogout,
    setStorageLogout,
    removeStorageLogout
  ] = useLocalStorage('@authApp: logout')

  const history = useHistory()

  const [
    resumoNotificacoes,
    setResumoNotificacoes
  ] = useState<IResumoNotificacao>(null)
  const [loadingResumo, setLoadingResumo] = useState(false)

  const [user, setUser] = useState<UserAuth>(null)
  const [loading, setLoading] = useState(true)
  const [loadingEnvioCodigoMFA, setLoadingEnvioCodigoMFA] = useState(false)
  const [loadingValidacaoCodigoMFA, setLoadingValidacaoCodigoMFA] = useState(
    false
  )

  const [hubConectado, setHubConectado] = useState<boolean>(false)
  // const [mfaData, setMfaData] = useState<any>(null)
  const [
    storageMfaEtapa1Data,
    setStorageMfaEtapa1Data,
    removeStorageMfaEtapa1Data
  ] = useLocalStorage('@authApp: mfaEtapa1Data')

  const [
    storageMfaEtapa2Data,
    setStorageMfaEtapa2Data,
    removeStorageMfaEtapa2Data
  ] = useLocalStorage('@authApp: mfaEtapa2Data')

  const [tutorialAberto, setTutorialAberto] = useState(false)

  const [pendenciaBacen, setPendenciaBacen] = useState<PendenciaBacenEstado | null>(
    null
  )
  const [carregandoPendenciaBacen, setCarregandoPendenciaBacen] = useState(false)
  const [avisoPendenciaBacenDispensado, setAvisoPendenciaBacenDispensado] = useState(
    false
  )
  const pedidoPendenciaRef = useRef(0)

  const { abrirModal } = useContext(ModalAtualizacoesContext)

  useEffect(() => {
    if (!!storageLogout) {
      removeStorageLogout()
      // alert('Usuário não tem acesso ou sessão expirada')
    }

    if (storageUser && storageToken) {
      setUser(storageUser)
      AddToken(storageToken)
      AddUserHeader(storageUser?.id)
    }

    if (storageProfile && storageTenant) {
      AddTenant(storageTenant)
      AddProfile(storageProfile)
    }

    if (storageMfaEtapa1Data) {
      setStorageMfaEtapa1Data(storageMfaEtapa1Data)
    }

    setLoading(false)
  }, [])

  useEffect(() => {
    verificaMostraTutorial()
  }, [
    user?.mostrarTutorial,
    user?.aceitouTermo,
    user?.aceitouPoliticaPrivacidade
  ])

  useEffect(() => {
    if (!storageUser?.id || !storageProfile || !storageTenant || !storageToken) {
      setPendenciaBacen(null)
      setCarregandoPendenciaBacen(false)
      return
    }

    if (!perfilConsultaPendenciaBacen(storageProfile)) {
      setPendenciaBacen(estadoSemPendencia)
      setCarregandoPendenciaBacen(false)
      return
    }

    // Garante headers antes da request (evita corrida com o efeito de bootstrap)
    AddToken(storageToken)
    AddTenant(storageTenant)
    AddProfile(storageProfile)
    AddUserHeader(storageUser.id)

    let ativo = true
    const pedido = ++pedidoPendenciaRef.current

    async function carregarPendencia() {
      setCarregandoPendenciaBacen(true)
      try {
        const { data } = await obterMinhasPendencias()
        if (!ativo || pedido !== pedidoPendenciaRef.current) return

        setPendenciaBacen({
          temPendencia: !!data?.temPendencia,
          dataLimite: data?.dataLimite ?? null,
          bloqueioAtivo: !!data?.bloqueioAtivo,
          total: data?.total ?? 0,
          itens: data?.itens ?? []
        })
      } catch {
        if (!ativo || pedido !== pedidoPendenciaRef.current) return
        setPendenciaBacen(estadoSemPendencia)
      } finally {
        if (ativo && pedido === pedidoPendenciaRef.current) {
          setCarregandoPendenciaBacen(false)
        }
      }
    }

    carregarPendencia()
    return () => {
      ativo = false
    }
  }, [storageUser?.id, storageProfile, storageTenant, storageToken])

  async function recarregarPendenciaBacen() {
    if (
      !storageUser?.id ||
      !storageProfile ||
      !storageTenant ||
      !storageToken ||
      !perfilConsultaPendenciaBacen(storageProfile)
    ) {
      setPendenciaBacen(estadoSemPendencia)
      return
    }

    AddToken(storageToken)
    AddTenant(storageTenant)
    AddProfile(storageProfile)
    AddUserHeader(storageUser.id)

    const pedido = ++pedidoPendenciaRef.current
    setCarregandoPendenciaBacen(true)
    try {
      const { data } = await obterMinhasPendencias()
      if (pedido !== pedidoPendenciaRef.current) return

      setPendenciaBacen({
        temPendencia: !!data?.temPendencia,
        dataLimite: data?.dataLimite ?? null,
        bloqueioAtivo: !!data?.bloqueioAtivo,
        total: data?.total ?? 0,
        itens: data?.itens ?? []
      })
    } catch {
      if (pedido !== pedidoPendenciaRef.current) return
      setPendenciaBacen(estadoSemPendencia)
    } finally {
      if (pedido === pedidoPendenciaRef.current) {
        setCarregandoPendenciaBacen(false)
      }
    }
  }

  function dispensarAvisoPendenciaBacen() {
    setAvisoPendenciaBacenDispensado(true)
  }

  function verificaMostraTutorial() {
    if (
      user?.mostrarTutorial &&
      storageProfile === SynPerfis.MEDICO &&
      !mostrouTutorialLogado &&
      user?.aceitouTermo &&
      user?.aceitouPoliticaPrivacidade
    ) {
      setTutorialAberto(true)
      setMostrouTutorialLogado(true)
    }
  }

  useEffect(() => {
    if (
      !!user &&
      !storageProfile &&
      (!(
        user.perfisPorTenant.length > 1 ||
        user.perfisPorTenant[0].perfis.length > 1
      ) ||
        !(user.perfis.length > 1))
    ) {
      setPerfilAtual(user.perfis[0], user.perfisPorTenant[0])
    }
    setTimeout(() => {
      if (!!storageUser?.id && !!storageProfile) {
        // console.log('auth', storageUser, user, storageProfile)
        atualizarResumo()
      }
    }, 1000)
  }, [user, storageUser, storageProfile])

  const signIn = async values => {
    setLoading(true)
    setStorageProfile(null)
    try {
      const { data: authMfaResponse } = await authLogin(values)
      let loginResponse = authMfaResponse.loginResponse
      if (loginResponse) {
        verificarLoginResponse(loginResponse)
      } else if (authMfaResponse.mfaEtapa1Response) {
        setStorageMfaEtapa1Data(authMfaResponse.mfaEtapa1Response)
        history.push(SynRoutes.mfaEtapa1)
        return true
      } else if (authMfaResponse.mfaEtapa2Response) {
        setStorageMfaEtapa2Data(authMfaResponse.mfaEtapa2Response)
        history.push(SynRoutes.mfaEtapa2)
        return true
      }
      return false
    } catch (error) {
      setLoading(false)
      showNotificationErrorAPI(error)
    }
  }

  const verificarLoginResponse = (loginResponse: AuthResponse) => {
    if (
      loginResponse &&
      loginResponse.verResumoAtualizacoes &&
      !loginResponse.primeiroAcesso &&
      loginResponse.perfis?.find(p => p === SynPerfis.OPERACIONAL)
    ) {
      abrirModal()
    }

    setUserSyn(loginResponse)
    removeStorageMfaEtapa1Data()
    removeStorageMfaEtapa2Data()
    return true
  }

  const setPrimeiroAcessoConfigurado = () => {
    let newUser = user
    newUser.primeiroAcesso = false
    setUser(newUser)
    setStorageUser(newUser)
  }

  function setAceitouTermo(value: number) {
    let newUser = user
    if (value === TipoTermo.privacidade) {
      newUser.aceitouPoliticaPrivacidade = true
    } else {
      newUser.aceitouTermo = true
    }
    verificaMostraTutorial()
    setUser(newUser)
    setStorageUser(newUser)
  }

  function obterNome() {
    if (!storageProfile) return ''
    if (storageProfile === SynPerfis.MEDICO) {
      return `Dr(a). ${
        user.perfisNome?.find(w => w.idPerfil === storageProfile)?.nome
      }`
    }

    return user.perfisNome?.find(w => w.idPerfil === storageProfile)?.nome
  }

  async function toggleTutorial(aberto: boolean, habilitado?: boolean) {
    if (!storageProfile) return ''
    if (
      aberto &&
      storageProfile === SynPerfis.MEDICO &&
      !!user &&
      user?.aceitouTermo &&
      user?.aceitouPoliticaPrivacidade
    ) {
      setTutorialAberto(aberto)
    } else {
      setTutorialAberto(false)
    }
    if (habilitado !== undefined) {
      try {
        await mostrarTutorial(habilitado)

        let novoUsuario = user
        novoUsuario.mostrarTutorial = habilitado
        setUser(novoUsuario)
        setStorageUser(novoUsuario)
      } catch (error) {
        console.log(error)
      }
    }
  }

  const setUserSyn: (response: AuthResponse) => void = response => {
    let user = {
      id: response.id,
      nome: response.nome,
      cpf: response.cpf,
      perfis: response.perfis,
      perfisPorTenant: response.perfisPorTenant,
      primeiroAcesso: response.primeiroAcesso,
      tipoParceiro: response.tipoParceiro,
      resetarToken: response.resetarToken,
      verResumoAtualizacoes: response.verResumoAtualizacoes,
      setorFuncionario: response.setorFuncionario,
      lstSetorFuncionario: response.lstSetorFuncionario,
      aceitouTermo: response.aceitouTermo,
      temPacote: response.temPacote,
      perfisNome: response.perfisNome,
      mostrarTutorial: response.mostrarTutorial,
      verDashboard: response.verDashboard,
      aceitouPoliticaPrivacidade: response.aceitouPoliticaPrivacidade
    }
    setUser(user)
    setStorageUser(user)
    setStorageToken(response.authToken)
    AddToken(response.authToken)
    AddUserHeader(user?.id)

    // setTimeout(() => {
    setLoading(false)
    // }, 3000)
  }

  const enviarCodigoMFA = async (canal: CanalDisponivel) => {
    setLoadingEnvioCodigoMFA(true)
    try {
      const { data: response } = await enviarCodigoMfaApi({
        token: storageMfaEtapa1Data.token,
        canalDisponivel: canal
      })

      setStorageMfaEtapa2Data(response)
      // Redireciona para a etapa 2
      history.push(SynRoutes.mfaEtapa2)
      return true
    } catch (error) {
      showNotificationErrorAPI(error)
    } finally {
      setLoadingEnvioCodigoMFA(false)
    }
  }

  const validarCodigoMFA = async (codigo: string) => {
    setLoadingValidacaoCodigoMFA(true)
    try {
      const { data: response } = await validarCodigoMfaApi({
        token: storageMfaEtapa2Data.token,
        codigo: codigo
      })

      verificarLoginResponse(response)
      history.push(SynRoutes.home)
      return true
    } catch (error) {
      showNotificationErrorAPI(error)
      console.error('Erro ao validar código MFA:', error)
      throw error
    } finally {
      setLoadingValidacaoCodigoMFA(false)
    }
  }

  const signOut = (redirecionar = true) => {
    //Todo: Ver se devo ignorar loading
    // setLoading(false)

    removeStorageUser()
    removeStorageToken()
    removeStorageProfile()
    removeStorageTenant()
    removeStorageMfaEtapa1Data()
    removeStorageMfaEtapa2Data()
    setTutorialAberto(false)
    setUser(null)
    setPendenciaBacen(null)
    setAvisoPendenciaBacenDispensado(false)
    setMostrouTutorialLogado(false)
    //Verificar redirecionamento por history
    if (redirecionar) {
      history.replace(SynRoutes.signin)
    }
  }

  const setPerfilAtual = (perfil: string, tenant: PerfilTentantResponse) => {
    if (
      user?.mostrarTutorial &&
      perfil === SynPerfis.MEDICO &&
      user?.aceitouTermo &&
      user?.aceitouPoliticaPrivacidade
    ) {
      setMostrouTutorialLogado(true)
      setTutorialAberto(true)
    }

    switch (perfil) {
      case SynPerfis.ADMIN_HOSPITAL:
      case SynPerfis.TESOURARIA_HOSPITAL:
      case SynPerfis.COTACAO_HOSPITAL:
      case SynPerfis.OPERACIONAL_HOSPITAL:
        // case SynPerfis.AGENDAMENTO:
        setSetorParceiro(perfil)
        if (!!user) {
          user.tipoParceiro = SynTipoParceiro.HOSPITAL_CLINICA.id
          setUser(user)
        }
        if (!!storageUser) {
          storageUser.tipoParceiro = SynTipoParceiro.HOSPITAL_CLINICA.id
          setStorageUser(user)
        }
        break
      // default:
      //   setSetorParceiro(null)
      //   break
    }
    AddTenant(tenant.tenantId)
    AddProfile(perfil)
    setStorageProfile(perfil)
    setStorageTenant(tenant.tenantId)
    setAvisoPendenciaBacenDispensado(false)
  }

  const clearPerfilAtual = () => {
    removeStorageProfile()
    removeStorageTenant()
    setStorageProfile(null)
    setStorageTenant(null)
  }

  function obterTenantAtual() {
    return user.perfisPorTenant.find(i => i.tenantId === storageTenant)
  }

  const setSetorParceiro = (setor: string) => {
    user.setorFuncionario = setor
    setStorageUser(user)
  }

  async function atualizarResumo() {
    try {
      if (storageUser && !!user && !!user?.id && !!storageProfile) {
        setLoadingResumo(true)
        const { data: resumo } = await _notificacoes.obterResumoNotificacoes()
        setResumoNotificacoes(resumo)
        setLoadingResumo(false)
      }
    } catch (error) {}
  }

  return (
    <AuthContext.Provider
      value={{
        signed: !!user,
        user,
        perfilAtual: storageProfile,
        tenantAtual: storageTenant,
        ehTenantSyn: storageTenant === tenantSyn,
        hubConectado,
        obterTenantAtual,
        setHubConectado,
        signIn,
        signOut,
        setUserSyn,
        setPerfilAtual,
        clearPerfilAtual,
        setSetorParceiro,
        setPrimeiroAcessoConfigurado,
        loading,
        setAceitouTermo,
        obterNome,
        toggleTutorial,
        tutorialAberto,
        loadingResumo,
        atualizarResumo,
        resumoNotificacoes,
        storageMfaEtapa1Data,
        storageMfaEtapa2Data,
        enviarCodigoMFA,
        validarCodigoMFA,
        loadingEnvioCodigoMFA,
        loadingValidacaoCodigoMFA,
        pendenciaBacen,
        carregandoPendenciaBacen,
        recarregarPendenciaBacen,
        avisoPendenciaBacenDispensado,
        dispensarAvisoPendenciaBacen
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext
